'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _commonMenuItemActiveNarrow = require('./commonMenuItemActiveNarrow');

var _commonMenuItemActiveNarrow2 = _interopRequireDefault(_commonMenuItemActiveNarrow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Common Menu Container
 * Contains general methods that can be used in primary and secondary navigation
 * @param {string} selector
 * @property {CommonMenuItemBuilder} itemBuilder
 * @property {CommonMenuItemActiveNarrow} activeItemNarrow
 * @constructor
 */
/**
 * @module navigation/commonMenu
 * @author: Serhii Atiahin [serhii.atiahin@racingpost.com]
 */

function CommonMenu(selector) {
    this.selector = selector;
}

/**
 * General navigation container selector
 * @type {*|jQuery|HTMLElement}
 */


/**
 * @type {CommonMenuItemActiveNarrow|Function|exports|module.exports}
 */
CommonMenu.prototype.navigationContainerSelector = '#navigationContainer';

/**
 * Get object of general navigation container
 * It's contains primary and secondary navigation
 * @protected
 * @returns {*|jQuery|HTMLElement}
 */
CommonMenu.prototype.getNavigationContainer = function () {
    var $navigationContainer = (0, _jquery2.default)(this.navigationContainerSelector);

    CommonMenu.prototype.getNavigationContainer = function () {
        return $navigationContainer;
    };

    return $navigationContainer;
};

/**
 * Initialization method
 * @protected
 * @returns {CommonMenu}
 */
CommonMenu.prototype.init = function () {
    /**
     * Menu container object
     * @type {*|jQuery|HTMLElement}
     */
    this.$obj = (0, _jquery2.default)(this.selector);

    /**
     * Parse server side rendered items
     * @type {Array}
     */
    this.items = this.parseDOM();

    this.updateActiveNarrowItem();

    /**
     * Bind events
     */
    if (this._bindEvents instanceof Function) {
        this._bindEvents();
    }

    return this;
};

/**
 * Add new menu item
 * @public
 * @param {string} title
 * @param {string} href
 * @param {int} [position]
 * @param {object} [attributes]
 * @returns {CommonMenu}
 */
CommonMenu.prototype.addItem = function (title, href, position, attributes) {
    var lowerCaseTitle = title.toLowerCase(),
        existingItems = this.items.filter(function (obj) {
        return obj.title.toLowerCase() === lowerCaseTitle;
    });

    if (existingItems.length > 0) {
        throw new Error('Item with the same title is already exists!');
    }

    this._insertItem(this.itemBuilder.getMenuItem(title, href, attributes), position);

    return this;
};

/**
 * Mark item to be removed
 * @public
 * @param {CommonMenuItem} menuItem
 * @returns {CommonMenu}
 */
CommonMenu.prototype.removeItem = function (menuItem) {
    menuItem.toBeRemoved = true;
    return this;
};

/**
 * Set menu item active
 * @public
 * @param {CommonMenuItem} menuItem
 * @returns {CommonMenu}
 */
CommonMenu.prototype.setActiveItem = function (menuItem) {
    /**
     * Deselect current selected item
     */
    var activeItem = this.getActiveItem();
    if (activeItem) {
        activeItem.isActive = false;
    }

    if (menuItem) {
        menuItem.isActive = true;
    }

    return this;
};

/**
 * Get object of highlighted menu item
 * @public
 * @returns {CommonMenuItem}
 */
CommonMenu.prototype.getActiveItem = function () {
    var activeItems = this.items.filter(function (obj) {
        return !!obj.isActive;
    });

    if (activeItems.length === 0) {
        return null;
    }

    if (activeItems.length > 1) {
        throw new Error('Something went wrong! Unexpected number of active items!');
    }

    return activeItems[0];
};

/**
 * Apply all changes to DOM
 * @public
 * @returns {CommonMenu}
 */
CommonMenu.prototype.render = function () {
    this.items = this.items.filter(function (item) {
        return item && !item.toBeRemoved;
    });

    var updatedItems = [];
    for (var itemIndex in this.items) {
        if (!this.items.hasOwnProperty(itemIndex)) {
            continue;
        }

        var item = this.items[itemIndex];

        item.render();
        updatedItems.push(item.$obj);
    }

    this.updateActiveNarrowItem();

    this.$obj.empty().append(updatedItems);

    return this;
};

/**
 * @protected
 */
CommonMenu.prototype.updateActiveNarrowItem = function () {
    if (!(this.activeItemNarrow instanceof _commonMenuItemActiveNarrow2.default)) {
        return;
    }

    var activeItem = this.getActiveItem();

    if (activeItem) {
        this.activeItemNarrow.setTitle(activeItem.getTitle());
        this.activeItemNarrow.setHref(activeItem.getHref());
        this.activeItemNarrow.addClasses(activeItem.getJsClasses());
    }
};

/**
 * Get menu item by position
 * @public
 * @param {int} position
 * @returns {CommonMenuItem}
 */
CommonMenu.prototype.getItemByPosition = function (position) {
    return this.items[position];
};

/**
 * Get menu item by title
 * @public
 * @param {string} title
 * @returns {CommonMenuItem}
 */
CommonMenu.prototype.getItemByTitle = function (title) {
    var lowerCaseTitle = title.toLowerCase();

    var selectedItems = this.items.filter(function (item) {
        return item.title.toLowerCase() === lowerCaseTitle;
    });

    return selectedItems[0];
};

/**
 * Get item or items by selector
 * @public
 * @param {string} selector
 * @returns {Array}
 */
CommonMenu.prototype.getItemsBySelector = function (selector) {
    var selectedPositions = this.getPositionsBySelector(selector);

    return this.items.filter(function (item, position) {
        return selectedPositions.indexOf(position) !== -1;
    });
};

/**
 * Insert menu item on specific position
 * @private
 * @param {CommonMenuItem} menuItem
 * @param {int} [position]
 */
CommonMenu.prototype._insertItem = function (menuItem, position) {
    if (_jquery2.default.isNumeric(position)) {
        if (this.getItemByPosition(position)) {
            this.items.splice(position, 0, menuItem);
        } else {
            this.items[position] = menuItem;
        }
    } else {
        this.items.push(menuItem);
    }
};

/**
 * Get positions of elements of menu that match selector
 * @protected
 * @param {string } selector
 * @returns {Array}
 */
CommonMenu.prototype.getPositionsBySelector = function (selector) {
    var positions = [];

    this.items.forEach(function (item, position) {
        if (item.hasSelector(selector)) {
            positions.push(position);
        }
    });

    return positions;
};

/**
 * Create array of items that were rendered by server side
 * @protected
 * @returns {Array}
 */
CommonMenu.prototype.parseDOM = function () {
    var self = this,
        items = [],
        $renderedItems = this.getRenderedItems();

    $renderedItems.each(function () {
        items.push(self.itemBuilder.getMenuItem((0, _jquery2.default)(this)));
    });

    return items;
};

/**
 * Get jQuery object of rendered items
 * @protected
 * @returns {jQuery}
 */
CommonMenu.prototype.getRenderedItems = function () {
    return this.$obj.find(this.itemSelector);
};

exports.default = CommonMenu;


//////////////////
// WEBPACK FOOTER
// ./~/rp-navigation/lib/navigation/commonMenu.js
// module id = 1020
// module chunks = 1